import { redirect } from "@tanstack/react-router";
import { HOKAGE_SERVICE_ENDED_PATH } from "~/constants/hokageMigration";
import { useAuthStore } from "~/stores/useAuthStore";
import { shouldBlockHokageService } from "./hokageMigration";

/** ルート入口のガード。締め切り以降の Hokage はログアウトしてサービス終了画面へ（終了画面自体はループさせない） */
export const guardHokageServiceCutoff = (
  pathname: string,
  now: Date = new Date(),
): void => {
  if (!shouldBlockHokageService(now)) return;
  useAuthStore.getState().logout();
  if (pathname.replace(/\/$/, "") === HOKAGE_SERVICE_ENDED_PATH) return;
  throw redirect({ to: HOKAGE_SERVICE_ENDED_PATH, replace: true });
};
